/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const FeetIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M29.3 29.4c-1.6-8.5-3-16.8-6.8-24.7-.4-.8-.7-1.6-.8-2.5-.1-.9.4-1.7 1.1-2.2h.6c.3.1.5.3.6.6 5.2 9.3 6.8 20.3 7.1 31 .2 1.3-.1 2.6-.7 3.7-1.2 1.2-2.7 2-4.4 2.2-4.5 1.3-8.7 4.3-13.4 4.3-1.4-.2-2.8-.1-4.2.3-1.3.5-2.3 2.2-1.4 3.3.7.6 1.6.9 2.5.6.9-.3 1.7-.5 2.6-.6 2.2-.2 4.1 1.6 6.2 2 2.2.2 4.4 0 6.5-.8 3.5-.8 7.1-.7 10.5.1 1.2.4 2.5.6 3.7.8 1.3.1 2.6-.3 3.5-1.1 1.6-1.7.9-4.4.3-6.7-2.7-9.4-3.1-19.3-1.2-28.8.2-1.7.9-3.4 2.1-4.7.8 2.3.9 4.8.1 7.2-1.6 7.8-1.3 15.8.7 23.5.7 2.1 1.2 4.2 1.4 6.4.2 2.2-.8 4.4-2.5 5.7-2.2 1.5-5.1.8-7.7.3-3.4-.9-6.8-1-10.3-.4-2.3.9-4.7 1.2-7.2 1.1-1.8-.4-3.4-1.6-5.2-1.9-2.2-.3-4.5.7-6.6 0-2-.8-3-3.1-2.3-5.2.7-1.4 2-2.5 3.5-2.9 1.5-.4 3.1-.7 4.7-.7 4.8-.5 9.5-2 13.7-4.2 1.3-.5 2.4-1.6 2.7-3' />
		</svg>
	)
}

export default FeetIcon
